import { environment } from "models/Environment";
import { createContext } from "react";

export interface User {
  name: string;
  username: string;
  id: string;
}

export interface IAuthentication {
  currentUser: User;
  acquireTokenSilent: (scopes?: string[] | undefined) => Promise<string>;
  logout: () => void;
}

export const AuthenticationContext = createContext<IAuthentication | undefined>(undefined);

export const defaultScopes = [`${environment.applicationIdUrl}/user_impersonation`];
